var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b-button',{staticClass:"p-0",staticStyle:{"font-size":"12px"},attrs:{"variant":"link","size":"sm"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.isShown ? 'Hide' : 'Show')+" details ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }